export const minWidth = 320;
export const navMenuWidth = 260;
export const headerHeight = 64;
export const footerHeight = 32;
export const bridgeBarHeight = 35;
